import { createFileRoute } from '@tanstack/react-router'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Building2, Mail, Zap, Settings } from "lucide-react"
import { Link } from '@tanstack/react-router'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb'
import { Separator } from '@/components/ui/separator'
import { SidebarTrigger } from '@/components/ui/sidebar'

export const Route = createFileRoute('/_app/settings/integrations/')({
    component: IntegrationsPage,
})

function IntegrationsPage() {
    const integrations = [
        {
            id: 'quickbooks',
            name: 'QuickBooks Online',
            description: 'Sync contribution data to your QuickBooks Online account',
            icon: Building2,
            status: 'available',
            href: '/settings/integrations/quickbooks'
        },
        {
            id: 'mailchimp',
            name: 'Mailchimp',
            description: 'Sync donor information with your Mailchimp lists',
            icon: Mail,
            status: 'coming-soon',
            href: '#'
        },
        {
            id: 'zapier',
            name: 'Zapier',
            description: 'Connect CoolFocus to thousands of apps through Zapier',
            icon: Zap,
            status: 'coming-soon',
            href: '#'
        }
    ]

    return (
        <>
            <header
                className={`sticky top-0 flex shrink-0 items-center gap-2 p-2 bg-white border-b-4 border-l-gray-200 border-r-gray-200 border-t-gray-200 border-t-2`}
            >
                <SidebarTrigger className="-ml-1" />
                <Separator orientation="vertical" className="mr-2 h-4" />
                <Breadcrumb>
                    <BreadcrumbList>
                        <BreadcrumbItem className="hidden md:block">
                            <BreadcrumbLink asChild>
                                <Link to='/settings'>
                                    Settings
                                </Link>
                            </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbSeparator className="hidden md:block" />
                        <BreadcrumbItem>
                            <BreadcrumbPage>
                                Integrations
                            </BreadcrumbPage>
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
            </header>

            <div className="h-full w-full p-6 bg-gray-100 overflow-auto">
                <div className="space-y-6">
                    <div>
                        <h1 className="text-3xl font-bold">Integrations</h1>
                        <p className="text-muted-foreground">
                            Connect CoolFocus with your favorite tools and services
                        </p>
                    </div>

                    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {integrations.map((integration) => {
                            const Icon = integration.icon

                            return (
                                <Card key={integration.id} className="relative">
                                    <CardHeader>
                                        <div className="flex items-center gap-3">
                                            <div className="p-2 bg-primary/10 rounded-lg">
                                                <Icon className="h-6 w-6 text-primary" />
                                            </div>
                                            <div className="flex-1">
                                                <CardTitle className="text-lg">{integration.name}</CardTitle>
                                                {integration.status === 'available' ? (
                                                    <Badge variant="secondary" className="text-xs">Available</Badge>
                                                ) : (
                                                    <Badge variant="outline" className="text-xs">Coming Soon</Badge>
                                                )}
                                            </div>
                                        </div>
                                    </CardHeader>
                                    <CardContent>
                                        <CardDescription className="text-sm mb-4">
                                            {integration.description}
                                        </CardDescription>

                                        {integration.status === 'available' ? (
                                            <Link
                                                to={integration.href as any}
                                                className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
                                            >
                                                <Settings className="h-4 w-4" />
                                                Configure
                                            </Link>
                                        ) : (
                                            <div className="text-sm text-muted-foreground">
                                                Available soon
                                            </div>
                                        )}
                                    </CardContent>
                                </Card>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}
